// extracted by mini-css-extract-plugin
export default {"button":"Checkbox_button__iCW3L","checkbox":"Checkbox_checkbox__cqTC-","content":"Checkbox_content__hL-GX","icon":"Checkbox_icon__P0Xk1","name":"Checkbox_name__G9LJb"};